export default __webpack_public_path__ + "static/media/VEB_wholeLife.7ef994d7.png";